export default "/build/client/static/fonts/SoderbergSans-MediumItalic.woff";